import { create } from "zustand";
interface SplashState {
  splash: boolean;
  toggleSplash: (value: boolean) => void;
}
export const useSplashStore = create<SplashState>((set) => ({
  splash: false,
  toggleSplash: (value: boolean) => {
    if (value) set(() => ({ splash: true }));
    else setTimeout(() => set(() => ({ splash: false })), 800);
  },
}));
